import { MasterTranslation } from '@/constants';
import { useGlobalState } from '@/hooks';
import { useEmailSyncContext } from '@/modules/pmt/context';
import type { FC } from 'react';
import {
  BannerHeader,
  BannerMainText,
  BannerSubText,
  ButtonCloseIcon,
  CloseIcon,
  SyncIcon,
  SyncInProgressContainer,
} from './SyncInProgressBanner.styles';

export const SyncInProgressBanner: FC = () => {
  const { t } = useGlobalState();
  const { isSyncing, onDismissSyncing } = useEmailSyncContext();
  const mainText = t(MasterTranslation.SyncingBannerMainText);
  const subText = t(MasterTranslation.SyncingBannerSubText);

  if (!mainText || !isSyncing) return null;

  return (
    <SyncInProgressContainer>
      <ButtonCloseIcon aria-label='Close Sync In Progress Banner' onClick={onDismissSyncing}>
        <CloseIcon />
      </ButtonCloseIcon>
      <BannerHeader>
        <SyncIcon />
        <BannerMainText>{mainText}</BannerMainText>
      </BannerHeader>
      <BannerSubText>{subText}</BannerSubText>
    </SyncInProgressContainer>
  );
};
